export default "__VITE_ASSET__07cddc6a__"